/**
 * External dependencies
 */

import React from 'react';
import classNames from 'classnames';

/**
 * Style dependencies
 */
import './styles.scss';

const FormSelect = (props) => {
    const { inputRef, className, isError, isCompact, ...rest } = props;
    const classes = classNames(className, 'form-select', {
        'is-error': isError,
        'is-compact': isCompact
    });

    return (
        <select {...rest} ref={inputRef} className={classes}>
            {props.children}
        </select>
    );
};

export default FormSelect;
